/**
 * GovernmentCategoryNav — sticky sub-nav for /government/* pages.
 */
import { Link, NavLink } from "react-router-dom";
import { Landmark, Building2, Bell, Inbox, Home } from "lucide-react";

const TABS = [
  { to: "/government",              key: "home",       label: "Home",         icon: Home,      exact: true },
  { to: "/government/departments",  key: "departments",label: "Departments",  icon: Building2 },
  { to: "/government/notices",      key: "notices",    label: "Public Notices", icon: Bell },
  { to: "/government/my-messages",  key: "my-messages",label: "My Messages",  icon: Inbox },
];

export default function GovernmentCategoryNav() {
  return (
    <nav className="sticky top-0 z-20 backdrop-blur-md border-b overflow-x-auto"
         style={{ background: "rgba(253,251,247,0.85)", borderColor: "var(--wofy-border)" }}
         data-testid="government-nav">
      <div className="max-w-6xl mx-auto flex items-center gap-1 px-3 py-2">
        <Link to="/government" className="inline-flex items-center gap-1 text-xs opacity-70 hover:opacity-100 pr-2 md:pr-3 border-r"
              style={{ borderColor: "var(--wofy-border)" }} data-testid="government-nav-brand">
          <Landmark className="w-3.5 h-3.5" /> Ask Your Government
        </Link>
        {TABS.map(({ to, key, label, icon: Icon, exact }) => (
          <NavLink key={key} to={to} end={exact}
            className={({ isActive }) =>
              `whitespace-nowrap inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-full transition ${
                isActive ? "bg-black text-white" : "hover:bg-black/5"
              }`
            }
            data-testid={`government-nav-${key}`}>
            <Icon className="w-3.5 h-3.5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
